module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "register-text"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t("welcome.header")) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "textbox",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome.description'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('GoogleButton'), _vm._v(" "), _c('div', {
    staticClass: "registratio-disclaimer-text"
  }, [_vm._v("\n      ההרשמה למערכת מהווה אישור לקריאה והסכמה ל"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('terms')
      }
    }
  }, [_vm._v("תנאי השימוש")]), _vm._v(" ול"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('privacy')
      }
    }
  }, [_vm._v("מדיניות הפרטיות")]), _vm._v(" שלנו.\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fff24ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome/welcome.vue
// module id = 494
// module chunks = 15